import { connect } from 'react-redux';

import { IApplicationState } from '../../types/redux';
import { IStickHeaderProps, StickHeader } from '../../components/StickHeader';
import { scrollTo } from '../../utils/scrollTo';
import { defaultState as defaultStateFeedback } from '../../reducers/feedback';

interface IFeedbackTopPosition {
  feedbackTopPosition: number;
}
type TStoreProps = Pick<IStickHeaderProps, 'isVisible'> & IFeedbackTopPosition;

export function mapStateToProps(state: IApplicationState): TStoreProps {
  const isVisibleForm =
    typeof state.feedback.isVisibleForm === 'boolean'
      ? state.feedback.isVisibleForm
      : (defaultStateFeedback.isVisibleForm as boolean);

  return {
    isVisible: state.stickHeader.isVisible && isVisibleForm,
    feedbackTopPosition: state.feedback.topPosition,
  };
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function mergeProps(stateProps: TStoreProps, _: void) {
  const { isVisible, feedbackTopPosition } = stateProps;

  return {
    isVisible,
    onClick: () => scrollTo(feedbackTopPosition),
  };
}

export const StickHeaderContainer = connect(mapStateToProps, null, mergeProps)(StickHeader);
